import React from 'react'
import './AboutHeader.css'

const AboutHeader = () => {
  return (
    <div className="about-header">
        <h3>About Us</h3>
        <p>What makes inertiaart stand out amongst others?<br /> What is it about us?</p>
    </div>
  )
}

export default AboutHeader